let baseUrl = '';

// Safely check for process.env (may not exist in browser if webpack hasn't replaced it)
if (typeof process !== 'undefined' && process.env) {
	if (process.env.NODE_ENV === 'development' && process.env.DEV_API_URL) {
		baseUrl = process.env.DEV_API_URL;
	}
}

const fetchBaseUrl = baseUrl;

export { fetchBaseUrl };
